import AppComponent from '../../mixins/app-component'

import AppCountdown from '../app-countdown'
import AppIcon from '../app-icon'
import AppInputEmail from '../app-input-email'
import AppSocialsLinks from '../app-socials-links'

export default
{
    name: 'app-home-mobile',

    mixins: [
        AppComponent
    ],

    components: {
        AppCountdown,
        AppIcon,
        AppInputEmail,
        AppSocialsLinks
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-home-mobile/script.js